import getPlanPrices from "@/redux/slices/store/thunks/getPlanPrices";
import getStoreReviews from "@/redux/slices/store/thunks/getStoreReviews";
import getSiteVersion from "@/redux/slices/store/thunks/getSiteVersion";
import getStoreArticles from "@/redux/slices/store/thunks/getStoreArticles";
import getTlds from "@/redux/slices/store/thunks/getTlds";
import getTldPrices from "@/redux/slices/store/thunks/getTldPrices";

const thunks = [
  getTlds,
  getTldPrices,
  getStoreReviews,
  getPlanPrices,
  getSiteVersion,
  getStoreArticles,
];

export default thunks;
